// shared-types/src/holiday/types.ts

export enum HolidayType {
    /** Business is expected to be closed. Default: excluded from delivery calculation. */
    NON_WORKING = 'NON_WORKING',
    /** Business may choose to work. Default: included in delivery calculation. */
    WORKING = 'WORKING',
}

export interface Holiday {
    id: string
    /** ISO date string "YYYY-MM-DD" */
    date: string
    /** ISO 3166-1 alpha-2 country code (e.g. "UY", "AR") */
    country: string
    name: string
    type: HolidayType
    createdAt: Date
    updatedAt: Date
}

export interface AccountHolidaySchedule {
    id: string
    accountId: string
    holidayId: string
    /** Whether the account will operate on this holiday */
    isOpen: boolean
    respondedAt: Date
    /** Tracks whether a reminder has already been sent */
    reminderSentAt?: Date | null
    createdAt: Date
    updatedAt: Date
}
